export * from './StartScreen';
export { default } from './StartScreen';
